import { useEffect, useState } from "react";

interface Section {
  id: string;
  label: string;
}

const sections: Section[] = [
  { id: "hero", label: "Home" },
  { id: "built-for", label: "How it works" },
  { id: "journey", label: "The journey" },
  { id: "cta", label: "Start" },
];

export const SectionNav = () => {
  const [activeId, setActiveId] = useState<string>("hero");

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight / 3;

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i].id);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveId(sections[i].id);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav
      className="fixed right-4 top-1/2 -translate-y-1/2 z-40 hidden lg:flex flex-col items-center gap-3"
      aria-label="Page sections"
    >
      {sections.map((section) => (
        <button
          key={section.id}
          onClick={() => scrollToSection(section.id)}
          className="group relative flex items-center justify-center w-3 h-3 rounded-full transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
          aria-label={`Go to ${section.label}`}
          aria-current={activeId === section.id ? "true" : undefined}
        >
          <span
            className={`absolute inset-0 rounded-full transition-all duration-300 ${
              activeId === section.id
                ? "bg-accent scale-125"
                : "bg-foreground/20 group-hover:bg-foreground/40"
            }`}
          />
          <span className="absolute right-6 px-2 py-1 rounded-md bg-card border border-border text-xs font-medium text-foreground opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap shadow-soft pointer-events-none">
            {section.label}
          </span>
        </button>
      ))}
    </nav>
  );
};
